module.exports = __webpack_public_path__ + "img/9. Calendar.d7ac0fcb.svg";